<p>update-payment-method works!</p>
